/**
 * Admin Login — kullanıcı adı + parola.
 *
 * User-friendly: büyük input, brand color, Türkçe hata mesajları.
 */
import {
  Button, Center, Container, Paper, PasswordInput,
  Stack, Text, TextInput, Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { IconChefHat } from "@tabler/icons-react";
import { useState } from "react";
import { useAuth } from "../../../shared/auth";

export function LoginPage({ app = "ADMIN" }: { app?: string } = {}) {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: { username: "", password: "", tenantSlug: "" },
    validate: {
      username: (v) => (!v ? "Kullanıcı adı zorunlu" : null),
      password: (v) => (!v ? "Parola zorunlu" : null),
    },
  });

  async function onSubmit(values: typeof form.values) {
    setLoading(true);
    try {
      await login(values.username, values.password, values.tenantSlug || undefined, app);
      notifications.show({
        title: "Giriş başarılı",
        message: "Hoş geldiniz!",
        color: "green",
      });
    } catch (e: any) {
      notifications.show({
        title: "Giriş hatası",
        message:
          e?.response?.data?.detail ||
          "Kullanıcı adı veya parola hatalı",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Center mih="100vh" style={{ background: "linear-gradient(135deg,#667eea,#764ba2)" }}>
      <Container size="xs" w={420}>
        <Paper shadow="xl" radius="lg" p="xl" withBorder>
          <Stack align="center" gap="md" mb="lg">
            <IconChefHat size={56} color="#667eea" />
            <Title order={2}>Restoran Yönetim</Title>
            <Text c="dimmed" size="sm">
              Hesabınızla giriş yapın
            </Text>
          </Stack>

          <form onSubmit={form.onSubmit(onSubmit)}>
            <Stack>
              <TextInput
                label="Kullanıcı Adı"
                placeholder="ahmet"
                size="md"
                required
                {...form.getInputProps("username")}
              />
              <PasswordInput
                label="Parola"
                placeholder="••••••"
                size="md"
                required
                {...form.getInputProps("password")}
              />
              <TextInput
                label="Tenant (opsiyonel)"
                placeholder="restoran-slug"
                size="md"
                {...form.getInputProps("tenantSlug")}
              />
              <Button type="submit" size="md" fullWidth mt="md" loading={loading}>
                Giriş Yap
              </Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Center>
  );
}
